export const EMPTY_VALUE = "-/-";
export const CURRENCY = "$";
